import { useEffect } from 'react';

function useBeforeUnload(isActive?: boolean) {
  useEffect(() => {
    const eventListener = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    if (isActive) {
      window.addEventListener('beforeunload', eventListener);
    }
    return () => {
      window.removeEventListener('beforeunload', eventListener);
    };
  }, [isActive]);
}

export default useBeforeUnload;
